import QuestionnaireScheduleFrequencySelect from '../Modules/Base/Components/Inputs/QuestionnaireScheduleFrequencySelect/QuestionnaireScheduleFrequencySelect';
import HealthCareRegulationCaseTypeSelectField from '../Modules/Base/Components/Inputs/HealthInsuranceCompanySelect/HealthInsuranceCompanySelectField';

export enum MagicField {
	TEXT = 'text',
	IMAGE = 'image',
	TEXT_FIELD = 'textfield',
	MULTIPLIER = 'multiplier',
	MULTIPLIER_REMOVE_BUTTON = 'multiplier_remove_button',
	TEXTAREA = 'textarea',
	SELECT = 'select',
	NUMBER = 'number',
	RADIOLIST = 'radio_list',
	CHECKBOX = 'checkbox',
	TITLE = 'title',
	COLLAPSE = 'collapse',
	LABEL = 'label',
	HR = 'hr',
	CUSTOMTEXT = 'customtext',
	BLOODPRESSURE = 'bloodpressure',
	GLYCAEMIA = 'glycaemia',
	GLUCOSE = 'glucose',
	DIAGNOSIS_LATAM = 'diagnosis_latam',
	BMI = 'bmi',
	SUBMIT = 'submit',
	CONDITION = 'condition',
	CONTAINER = 'container',
	HSTACK = 'hstack',
	V_STACK = 'vstack',
	HIDDEN = 'hidden',
	WHITESPACE = 'white_space',
	QUESTIONNAIRE_SELECT = 'questionnaire_select',
	PATIENT_SELECT = 'patient_select',
	DOCTOR_SELECT = 'doctor_select',
	TIMEPICKER = 'timepicker',
	DATEPICKER = 'datepicker',
	NZCI_VACCINATION_KIND = 'nczi_vaccination_kind',
	NZCI_VACCINATION_TYPE = 'nczi_vaccination_type',
	NZCI_SPECIALIZATION = 'nczi_specialization',
	NZCI_STATE = 'nczi_state',
	NCZI_EXAMINATION_URGENCY = 'nczi_examination_urgency',
	NCZI_ALLERGENS = 'nczi_allergens',
	NCZI_ATC_CLASSIFICATION_SYSTEM = 'nczi_atc_classification_system',
	NCZI_IMPLANTED_MEDICAL_DEVICES = 'nczi_implanted_medical_devices',
	NCZI_DIAGNOSIS = 'nczi_diagnosis',
	NCZI_RECOMMENDATION_FOR_EXAMINATION = 'nczi_recommendation_for_examination',
	NCZI_PROFESSIONAL_FOCUS = 'nczi_professional_focus',
	NCZI_EXAMINED_BODY_PART = 'nczi_examined_body_part',
	NCZI_MODALITY_OF_IMAGING_EXAMINATION = 'nczi_modality_of_imaging_examination',
	NCZI_SELECT = 'nczi_select',
	NCZI_SEARCH_SELECT = 'nczi_search_select',
	ORGANIZATION_UNIT_SELECT = 'organization_unit_select',
	PRICE_WITH_CURRENCY = 'price_with_currency',
	PHONE_NUMBER = 'phoneNumber',
	EMAIL = 'email',
	RICH_TEXT_FIELD = 'richTextField',
	DIAGNOSIS_CZECH = 'diagnosis_czech',
	VZP_REIMBURSEMENT = 'vzp_reimbursement',
	CASE_TYPE_REGULATION = 'case_type_regulation',
	QUESTIONNAIRE_SCHEDULE_FREQUENCY = 'questionnaire_schedule_frequency',
	FIELD_OF_CARE_SUKL_SELECT = 'field_of_care_sukl_select',
	FORM_OF_CARE_SELECT = 'form_of_care_select',
	CITIZENSHIP_SELECT = 'citizenship_select',
	HEALTH_INSURANCE_COMPANY_SELECT = 'health_insurance_company_select',
	GENDER = 'gender',
	WORKPLACE_SELECT = 'workplace_select',
	PATIENT_CONSENT_REQUEST = 'patient_consent_request',
	SUKL_MEDICAMENT_SELECT = 'sukl_medicament_select',
	TRANSLATIONS = 'translations',
	VAT_RATE = 'vat_rate',
	ROLE_MULTISELECT_WITH_CHECKLIST = 'role_multiselect_with_checklist',
	INSURANCE_COMPANIES_MULTISELECT_WITH_CHECKLIST = 'insurance_companies_multiselect_with_checklist',
	INSURANCE_COMPANY_BATCH_TYPES_MULTISELECT_WITH_CHECKLIST = 'insurance_company_batch_types_multiselect_with_checklist',
	P1_MEDICAMENT = 'p1_medicament',
	P1_PAYMENT_COVERAGE_TYPE = 'p1_payment_coverage_type',
	P1_DOSAGE_INTERVAL_TYPE = 'p1_dosage_interval_type',
	P1_MEDICAL_FACILITY = 'p1_medical_facility',
	P1_DISEASES = 'p1_diseases',
	P1_PROCEDURES = 'p1_procedures',
	P1_MEDICAL_REQUEST_TYPE = 'p1_medical_request_type',
	IMAGE_UPLOAD = 'image_upload',
	STRIPE_CONFIGURATION_REQUEST_MESSAGE = 'stripe_configuration_request_message',
	ELECTRONIC_SIGNATURE = 'electronic_signature',
	SUBMIT_BUTTON = 'submitButton',
	PATIENT_HEADER = 'patient_header',
	COLOR_PICKER = 'color_picker',
	TERM_ITEM_SELECT = 'term_item_select',
	TERM_ITEM_ASYNC_SELECT = 'termItemAsyncSelect',
	DISCOURSE_TEXT_LOAD_BUTTON = 'discourseTextLoadButton',
	BUTTON = 'button',
}
